import axios from "axios"
import { getApiConfig } from "../authHelper"
import { API_URL } from "../url_helper"

const REPORT_EXPORT = "/report-export"

// The request asks for a file, so a server error arrives as a JSON blob. Read the message out of it.
const readBlobError = async error => {
  const blob = error?.response?.data
  if (blob instanceof Blob) {
    try {
      const parsed = JSON.parse(await blob.text())
      if (parsed?.message) return new Error(parsed.message)
    } catch (_) {
      // fall through to the generic message
    }
  }
  return new Error(error?.message || "Export failed")
}

const downloadExcel = async (path, params, filename) => {
  try {
    const response = await axios.get(`${API_URL}${REPORT_EXPORT}${path}`, {
      ...getApiConfig(),
      params,
      responseType: "blob",
      timeout: 0,
    })
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement("a")
    link.href = blobUrl
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    throw await readBlobError(error)
  }
}

export const downloadBusinessMetricsReport = ({ from, to, graceDays }) =>
  downloadExcel("/business-metrics", { from, to, graceDays }, `business-metrics-${from}-to-${to}.xlsx`)

export const downloadRenewalCustomersReport = ({ from, to }) =>
  downloadExcel("/renewal-customers", { from, to }, `renewal-customers-${from}-to-${to}.xlsx`)
